module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/sidebar-shield-inactive.8f21e72b.svg";